import React, { ReactNode } from 'react';

import * as styles from './PageHeader.module.scss';
import { ClientHeader } from '@ecosystem/newron-client-lib';
import MultiBannerRetailerSelector from '@components/multi-banner-retailer-selector/MultiBannerRetailerSelector';
import { RetailerClient } from '@models/RetailerClient';
import { ClientSubscription } from '@models/Opa';
import { ProductType } from '@pages/product-analyzer/Product';

type PageHeaderProps = {
  children: ReactNode;
  retailerClients: RetailerClient[];
  onChangeHandler: (subscription: ClientSubscription[]) => void;
  productType: ProductType;
};
const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const { children, retailerClients, onChangeHandler, productType } = props;
  return (
    <>
      <div className={styles.PageHeader}>{children}</div>
      <ClientHeader>
        <MultiBannerRetailerSelector
          retailerClients={retailerClients}
          onChangeHandler={onChangeHandler}
          productType={productType}
        />
      </ClientHeader>
    </>
  );
};

export default PageHeader;
